module.exports = __webpack_public_path__ + "static/apple-icon-180x180-55c7de6167fe4bcb653121088c2a57fe.png";